import React, { Component } from 'react';
import Overview from '../components/Overview';

class CompletedTestInstanceOverview extends Component {
    render() {
        const {
            comments,
            name,
            overviewList,
            updateComments,
            deleteTestInstance,
            testInstanceId
        } = this.props;

        return (
            <div className="test-instance-overview pull-right">
                <Overview
                    name={name}
                    comments={comments}
                    overviewList={overviewList}
                    updateComments={updateComments}
                />
                <a 
                href="#" 
                className="delete-device pull-left"        
                onClick={() => deleteTestInstance(testInstanceId)}
                >
                    Delete Instance
                </a>
            </div>
        )
    }
}

export default CompletedTestInstanceOverview;